import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'

export default ({ nameProp = 'name', latinNameProp = 'latinName', locale }) => {
  return class NameCell extends GridCell {
    render () {
      const value = locale === 'ar' ? (this.props.dataItem[nameProp] || this.props.dataItem[latinNameProp]) : (this.props.dataItem[latinNameProp] || this.props.dataItem[nameProp])
      return (<td>{value}</td>)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.NameCell.js